export const ARTICLE_ID = "260b5ea0-c40e-4511-b4cc-de5275a55fdf";
export const PLAYER_URL = "https://widgets-lp.narando.com/p";
export const API_URL = "https://api.narando.com";
